import React from "react";
import { List } from "semantic-ui-react";
import ArticleItem from "./ArticleItem";

// const ArticleList = (props) => {
//   return (
//     <List divided style={{ maxWidth: 900, margin: "0 auto" }}>
//       {props.articles.map((article) => (
//         <List.Item key={article.title}>{article.title}</List.Item>
//       ))}
//     </List>
//   );
// };

const ArticleList = (props) => {
  return (
    <List divided style={{ maxWidth: 900, margin: "0 auto" }}>
      {props.articles.map((article, index) => (
        <ArticleItem article={article} key={article.title + index} />
      ))}
    </List>
  );
};

export default ArticleList;
